import React from 'react'
import { useDispatch } from 'react-redux'
import { useEffectOnce } from 'react-use'
import { ListingTemplate } from 'components'
import { agencyApiEvents } from 'modules/api/agency'
import { useSegments } from '../SegmentsProvider'
import SegmentsSearchFilter from './SearchFilter'
import SegmentsTable from './SegmentsTable/SegmentsTable'

const SegmentsContent = (): React.ReactElement => {
  const dispatch = useDispatch()
  const { isLoading } = useSegments()

  useEffectOnce(() => {
    dispatch(agencyApiEvents.getSegments_request())
  })

  return <ListingTemplate loading={isLoading} Header={<SegmentsSearchFilter />} Body={<SegmentsTable />} />
}

export default SegmentsContent
